<template>
    <div class="auth__login-container">
        <div class="2fa-request auth__login__content" v-if="display2FAPopUp">
            <div>
                <div class="panel panel--login">
                    <div class="panel__header">
                        <strong>
                            2FA Authentication
                        </strong>
                    </div>
                    <div class="panel__content">
                        You don't have two-factor authentication (2FA) enabled.
                        Do you want to enable it?

                        <div class="row button-row">
                            <button class="btn btn-warning" @click="toggle2fa(false)">
                                Skip for Now
                            </button>
                            <button class="btn btn-success" @click="toggle2fa(true)">
                                Enable
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="auth__login__content" v-else>
            <div class="auth__login__brand-logo">
                <img src="/static/moneywave.png" width="220" height="auto" alt="Moneywave Logo" />
            </div>
            <div class="auth__login-form">
                <form v-if="twoFa" action="" @submit.prevent="submit2fa()">
                    <div class="panel panel--login">
                        <div class="panel__header">
                            <div class="panel__header__left">
                                Please enter the otp sent to your email
                            </div>
                        </div>
                        <div class="panel__content">
                            <!--email-->
                            <div class="auth__login__item">
                                <label for="otpnumber">OTP number</label>
                                <div class="otp-input-group">
                                    <span class="pre-otp">{{otpPrefix}}</span>
                                    <span class="connector">-</span>
                                    <input type="text" name="otp" v-model="otpValue" aria-required="true"
                                        aria-invalid="false">
                                </div>
                            </div>

                            <!--submit form-->
                            <div class="auth__login__item submit__login-form">
                                <button id="otpBtn" type="submit" class="btn btn--primary btn--block">
                                    SUBMIT
                                </button>
                            </div>
                        </div>
                    </div>
                </form>
                <form v-else action="" @submit.prevent="handleLogin()">
                    <div class="panel panel--login">
                        <div class="panel__header">
                            <div class="panel__header__left">
                                Login to<span> Moneywave</span>
                            </div>
                            <div class="panel__header__right">
                                <!-- <button id="signupBtn" class="btn btn--default"> Get a free account </button> -->
                                <router-link :to="{ name: 'signup-personal' }" class="btn btn--default">Get a free
                                    account</router-link>
                            </div>
                        </div>
                        <div class="panel__content">
                            <!--email-->
                            <div class="auth__login__item">
                                <label for="authLoginEmail">Your <span>email</span></label>
                                <input id="authLoginEmail" type="email" class="form__input" v-model="getEmail" />
                            </div>

                            <!--password-->
                            <div class="auth__login__item">
                                <label for="authLoginPassword">Your <span>password</span></label>
                                <input autocomplete="new-password" id="authLoginPassword" type="password"
                                    class="form__input" v-model="userPassword" />
                            </div>

                            <!--error field-->
                            <template v-if="errorExists">
                                <div class="form__errors" v-for="(err, index) in loginerrors" :key="index">
                                    <div class="form__errors__icon">
                                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                                            width="22" height="20" viewBox="0 0 22 20">
                                            <defs>
                                                <path id="apiicon"
                                                    d="M10.47 0C4.697 0 0 4.486 0 10s4.697 10 10.47 10c5.773 0 10.47-4.486 10.47-10S16.243 0 10.47 0m0 18c-4.618 0-8.376-3.589-8.376-8s3.758-8 8.376-8c4.619 0 8.376 3.589 8.376 8s-3.757 8-8.376 8m0-13c-.578 0-1.047.447-1.047 1v4c0 .553.47 1 1.047 1 .578 0 1.047-.447 1.047-1V6c0-.553-.469-1-1.047-1m0 8c-.578 0-1.047.447-1.047 1 0 .553.47 1 1.047 1 .578 0 1.047-.447 1.047-1 0-.553-.469-1-1.047-1">
                                                </path>
                                            </defs>
                                            <use fill="#9C6F19" fill-rule="evenodd" transform="translate(.935)"
                                                xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#apiicon"></use>
                                        </svg>
                                    </div>
                                    <div class="form__errors__text">
                                        {{ err }}
                                    </div>
                                </div>
                            </template>

                            <!--submit form-->
                            <div class="auth__login__item submit__login-form">
                                <button id="loginBtn" type="submit" class="btn btn--primary btn--block">
                                    LOGIN TO MONEYWAVE
                                </button>
                            </div>

                            <!--forgotpassword-->
                            <div class="auth__login__forgot-pass text-center">
                                <router-link :to="{ name: 'forgot-password' }" class="link">Forgot <span>your
                                        password?</span>
                                </router-link>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<style lang="scss">
@import "./../../assets/stylesheets/scss/auth";

.panel--login .panel__content {
    padding-left: 40px;
    padding-right: 40px;
}
</style>

<script>
import {
    login,
    refreshOTP,
    otp,
    enable2fa
} from "../../utils/auth/authService";
import { getUser } from "../../utils/user/getUserDetails";
import { mapState } from "vuex";
import { mapGetters } from "vuex";

export default {
    name: "Login",
    beforeMount() {
        if (Object.keys(this.$route.query).length > 0) {
            this.$cookies.set(
                "token",
                "Bearer " + this.$route.query.tk
            );
            window.localStorage.setItem("loginType", "redirect");
            this.getUserDetails();
        }
    },

    data() {
        return {
            isLoggedIn: false,
            userPassword: "",
            loginerrors: [],
            errorExists: false,
            twoFa: false,
            otpValue: "",
            otpPrefix: "",
            accessToken: "",
            display2FAPopUp: null
        };
    },

    computed: {
        getEmail: {
            get() {
                if (this.$store.state.authUser.email === "") {
                    return this.$store.state.isUser.email;
                } else {
                    return this.$store.state.authUser.email;
                }
            },
            set(value) {
                return this.$store.commit("updateUserEmail", value);
            }
        }
    },

    methods: {
        toggle2fa(status) {
            enable2fa(this.getEmail, status, false).then(res => {
                console.log(res);
                this.$router.push("/overview");
            });
        },
        submit2fa() {
            login(this.getEmail, this.userPassword, false, this.otpValue).then(
                res => {
                    if (res.status === 200) {
                        let token =
                            res.data.token_type + " " + res.data.access_token;
                        this.$cookies.set("token", token);
                        this.$cookies.set("productionToken", token);
                        window.localStorage.setItem("staging", false);
                        // this.$store.state.commit('updateMerchantList', res);
                        app.errorExists = false; //no error then, right?
                        this.loginerrors = [];
                        console.log(res.data);
                        if (res.data.access_token) {
                            //then get user details
                            this.getUserDetails().then(res =>
                                this.$router.push("/overview")
                            );
                        }
                    } else {
                        document.getElementById("loginBtn").disabled = false;
                    }
                }
            );
        },
        goToSignUp() {
            window.localStorage.clear();
            this.$router.push({ name: "signup-personal" });
        },
        handleLogin() {
            document.getElementById("loginBtn").disabled = true;
            let app = this;
            if (this.userPassword !== "" && this.getEmail !== "") {
                //start loader to show progress
                this.$Progress.start();

                //call get login token
                login(this.getEmail, this.userPassword, true)
                    .then(response => {
                        // if token is successfully gotten, cache that.
                        if (response.status === 200) {
                            if (response.data.twoFactorActive) {
                                this.$Progress.finish();
                                this.otpPrefix = response.data.otpPrefix ? response.data.otpPrefix : '----';
                                this.twoFa = response.data.twoFactorActive;
                            } else if (response.data.access_token) {
                                this.$Progress.finish();

                                let token =
                                    response.data.token_type +
                                    " " +
                                    response.data.access_token;
                                this.$cookies.set("token", token);
                                this.$cookies.set(
                                    "productionToken",
                                    token
                                );
                                window.localStorage.setItem("staging", false);
                                // this.$store.state.commit('updateMerchantList', response);
                                app.errorExists = false; //no error then, right?
                                this.loginerrors = [];

                                this.getUserDetails().then(res => {
                                    if (response.data.displayTwoFaPopup) {
                                        this.$Progress.finish();
                                        this.display2FAPopUp =
                                            response.data.displayTwoFaPopup;
                                    } else {
                                        this.$Progress.finish();
                                        this.$router.push("/overview");
                                    }
                                });
                            }
                        } else {
                            document.getElementById(
                                "loginBtn"
                            ).disabled = false;
                        }
                    })

                    //catch error from the login API and do something about the errors
                    .catch(error => {
                        // if (error.response.data.code === "MISSING_OTP") {
                        //     login(this.getEmail, this.userPassword).then(
                        //         response => {
                        //             // if token is successfully gotten, cache that.
                        //             if (response.status === 200) {
                        //                 if (response.data.twoFactorActive) {
                        //                     this.twoFa = true;
                        //                 }
                        //             } else {
                        //                 document.getElementById(
                        //                     "loginBtn"
                        //                 ).disabled = false;
                        //             }
                        //         }
                        //     );
                        // }
                        document.getElementById("loginBtn").disabled = false;
                        this.$Progress.fail();
                        this.errorExists = true;
                        this.loginerrors = [];
                        if (error.response.data.message === 'Invalid resource owner credentials') error.response.data.message = 'Invalid Email or password';
                        this.loginerrors.push(error.response.data.message)
                        console.log(this.loginerrors);
                        console.log(error);
                    });
            }

            //on frontend, if email and password isn't provided
            else {
                document.getElementById("loginBtn").disabled = false;
                this.$Progress.fail();
                this.errorExists = true;
                let error = "Please provide your email and password";
                this.loginerrors = [];
                this.loginerrors.push(error);
            }
        },
        getUserDetails() {
            //after login is successful, get user details.
            return (
                getUser()
                    .then(responseUser => {
                        this.$Progress.start();
                        //cache user details if getuser api call is successful
                        if (responseUser.status === 200) {
                            //route to overview on success
                            // this.$router.push("/overview");
                            console.log(responseUser);
                            this.$store.commit(
                                "updateMerchantList",
                                responseUser.data.merchants
                            );
                            this.$store.commit(
                                "updateUserFirstName",
                                responseUser.data.name
                            );
                            this.$store.commit(
                                "updateUserId",
                                responseUser.data.userId
                            );
                            window.localStorage.setItem(
                                "userId",
                                responseUser.data.userId
                            );
                            this.$store.commit(
                                "updateUserPhonenumber",
                                responseUser.data.phonenumber
                            );
                            this.$store.commit(
                                "updateUserEmail",
                                responseUser.data.email
                            );
                            this.$store.commit(
                                "updateUserBusinessName",
                                responseUser.data.merchants[0].name
                            );
                            this.$store.commit(
                                "updateUserAccountNumber",
                                responseUser.data.merchants[0].account
                            );
                            this.$store.commit(
                                "updateCompliance",
                                responseUser.data.merchants[0].compliance
                            );
                            this.$store.commit(
                                "updateUserMerchantId",
                                responseUser.data.merchants[0].id
                            );
                            this.$store.commit(
                                "updateUserMerchantPosState",
                                responseUser.data.merchants[0].posMerchant ||
                                false
                            );
                            // to be removed later
                            let permissions =
                                responseUser.data.merchants[0].permission || [];
                            if (
                                JSON.parse(
                                    window.localStorage.getItem("staging")
                                ) === true &&
                                permissions.length === 0
                            )
                                permissions = [
                                    "wallet.disburse",
                                    "wallet.list"
                                ];
                            this.$store.commit(
                                "updateUserPermissions",
                                permissions
                            );
                            console.log(this.$store.state.authUser.phoneNumber);
                            console.log(this.$store.state.authUser.compliance);
                            console.log(
                                this.$store.state.authUser.merchantList
                            );
                        }

                        return responseUser;
                    })

                    //catch error from the getuser API and do something about the errors
                    .catch(error => {
                        this.$Progress.fail();
                        this.loginerrors.push(error);
                        console.log(this.loginerrors);
                    })
            );
        }
    }
};
</script>

<style>
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

.button-row {
    margin-top: 30px;
    padding: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/auth/LoginPage.vue